var map = {
	"./c_chez_vous.svg": 53178,
	"./chronopost.svg": 98441,
	"./click_and_collect.svg": 80523,
	"./colissimo.svg": 8544,
	"./dpd.svg": 17114,
	"./kuehne_nagel.svg": 15094,
	"./mondial_relay.svg": 15348
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21440;